var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('img',{attrs:{"src":require("../assets/logo_sf.svg")}}),_c('a',{attrs:{"href":"#quellen"}},[_vm._v("Quellen")]),_c('a',{attrs:{"href":"#impressum"}},[_vm._v("Impressum")])])
}]

export { render, staticRenderFns }